import { render, staticRenderFns } from "./ModalMini.vue?vue&type=template&id=6cb43020&"
import script from "./ModalMini.vue?vue&type=script&lang=js&"
export * from "./ModalMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports